require('lessRoot/rebates.less');

(function($) {

	Blain.rebates = {

		$departments: $('#rebateDepartments'),
		$searchForm: $("#rebateSearchForm"),
		$searchInput: $("#rebateSearchInput"),
		$rebateList: $("#rebateList"),

		init() {
			if (!this.$searchForm.length) return;
			const self = this;

			self.$searchForm.on('submit', function(e) {
				e.preventDefault();
				self.search();
			});

			self.$departments.on('change', function(e) {
				e.preventDefault();
				self.filterByDepartment(e.target.value);
			});
		},

		search() {
			const $wait = $.modalProgress("Searching...");
			const query = this.$searchInput.val();
			const self = this;
			$.getJSON(`/rebates/a/search?query=${query}`, function(res) {
				if (res && res.html) {
					$("#content h1").text("Online Rebates");
					self.$rebateList.html(res.html);
					self.$departments.val("");
				}
				$wait.blainModal("hide");
			});
		},

		filterByDepartment(taxonomyID) {
			const self = this;
			const $wait = $.modalProgress("Please Wait...");
			$.getJSON(`/rebates/a/filter?taxonomyid=${taxonomyID}`, function(res) {
				if (res && res.html) {
					$("#content h1").text("Online Rebates");
					self.$searchInput.val("");
					self.$rebateList.html(res.html);
				}
				$wait.blainModal("hide");
			});
		}

	};


	$(document).ready(function() {
		Blain.rebates.init();
	});


})(jQuery);